import { userIdQuery } from '../../authentication/queries';
import { createCommand } from '../../utils';
import { setColumnVisibility, moduleName } from '../state';

const SaveColumnsPreference = createCommand(
    `${moduleName}/SAVE_COLUMNS_PREFERENCE`,
    async (model: Record<string, boolean>, { dispatch, extra, getState }) => {
        const userId = userIdQuery(getState());
        if (userId) {
            extra.externalSessionConfiguration.saveColumnVisibility(userId, model);
            dispatch(setColumnVisibility(model));
        }
    },
);

export default SaveColumnsPreference;
